export const DafaultBlockValues = {
    backgroundUrl: 'https://ucarecdn.com/d110c71c-fb74-4332-996e-2cf3323ce093/Cartmatepattern4.png',
    borderRadius: 16,
    height: 100,
    padding: 0,
    margin: 8,
    text: 'This is a sample text',
    color: '#4A90E200'
}